const DEFAULT_FONT_FAMILY = "'Source Sans Pro', -apple-system, Helvetica, sans-serif";
const MONO_FONT_FAMILY = "'Source Code Pro', monospace";

export {
  DEFAULT_FONT_FAMILY,
  MONO_FONT_FAMILY,
};



// WEBPACK FOOTER //
// ./src/Constants/fonts.js